/**
 * Utilitario para parsear entradas monetarias no formato BR ou US.
 */

/**
 * Converte uma string monetaria no formato BR ou US para number.
 *
 * Formatos aceitos:
 * - "R$ 25,50" → 25.5
 * - "25,50"    → 25.5
 * - "1.234,56" → 1234.56
 * - "25.50"    → 25.5 (formato US, sem separador de milhar)
 *
 * @returns O valor numerico, ou null se a string for invalida.
 */
export function parseCurrencyInput(value: string): number | null {
  if (!value || !value.trim()) return null;

  // Remove prefixo "R$" e espacos em branco
  let cleaned = value.replace(/R\$\s*/g, '').trim();
  if (!cleaned) return null;

  // Determina se e formato BR (usa virgula como decimal) ou US
  const hasComma = cleaned.includes(',');
  const hasDot = cleaned.includes('.');

  if (hasComma) {
    // Formato BR: ponto = separador de milhar, virgula = decimal
    // Remove pontos de milhar e substitui virgula por ponto
    cleaned = cleaned.replace(/\./g, '').replace(',', '.');
  } else if (hasDot) {
    // Pode ser US (25.50) ou milhar sem decimal (1.234)
    // Se houver exatamente um ponto e 2 casas decimais apos ele, e decimal US
    // Caso contrario, remove (e milhar sem decimal)
    const parts = cleaned.split('.');
    const lastPart = parts[parts.length - 1] ?? '';
    if (parts.length === 2 && lastPart.length <= 2) {
      // Trata como decimal US: mantém como esta
    } else {
      // Milhar sem decimal: remove pontos
      cleaned = cleaned.replace(/\./g, '');
    }
  }

  const result = parseFloat(cleaned);
  if (isNaN(result)) return null;
  return result;
}
